import { CommitteeMemberBase } from './committee-shared.model';

export interface CommitteeDto {
  CommitteeID: number;
  AffCode: string;
  CommitteeType: string;
  Name: string;
  Descr: string;
  Active: boolean;
  OnGoing: boolean;
  StartDate: Date;
  EndDate: Date;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  AssignedTo: string;
  Notes: string;
  IsPublic: boolean;
  MeetAddress1: string;
  MeetAddress2: string;
  MeetCity: string;
  MeetState: string;
  MeetZip: string;
  MeetZipExt: string;
  TermMonths: number;
  InactivateOnTermExpiration: boolean;
  CommitteeMembers: CommitteeMemberBase[];
}

export function initializedCommitteeDto(): CommitteeDto {
  return {
    Active: true,
    OnGoing: true,
    InactivateOnTermExpiration: true,
  } as CommitteeDto;
}
